import { Action, createAction, handleActions } from "redux-actions";
import {
  GetStatisticsCotizacionResponse,
  vEstadisticasCotizacion,
} from "~api/types";
import { Services } from "./types";

interface GetEstadisticasCompletedPayload {
  estadisticas: vEstadisticasCotizacion[];
  totalRegistros: number | undefined;
  isAnOldRequest?: boolean;
}

interface EstadisticasState {
  isLoading: boolean;
  estadisticas: vEstadisticasCotizacion[] | null;
  totalRegistros: number | undefined;
  failed?: boolean;
  isPageAlreadyLoad?: boolean;
  take?: number | string;
}

const setInitialState = createAction("SET_ESTADISTICAS_INITIAL_STATE");

const getEstadisticasInited = createAction("OBTENER_ESTADISTICAS_INITED");

const getEstadisticasCompleted = createAction(
  "OBTENER_ESTADISTICAS_COMPLETED",
  (
    response: GetStatisticsCotizacionResponse | null | undefined,
    isAnOldRequest?: boolean
  ): GetEstadisticasCompletedPayload => {
    let estadisticas: vEstadisticasCotizacion[] = [];
    let totalRegistros: number | undefined = 0;

    if (response != null) {
      estadisticas = response.companias;
      // El backend no manda totalRegistros (ver GetStatisticsCotizacionResponse):
      // acá queda undefined, igual que hasta ahora.
      totalRegistros = (response as Partial<{ totalRegistros: number }>)
        .totalRegistros;
    }

    return { estadisticas, totalRegistros, isAnOldRequest };
  }
);
const getEstadisticasFailed = createAction(
  "OBTENER_ESTADISTICAS_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getEstadisticas = () => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getEstadisticasInited());
      const response = await services.api.estadisticas().getEstadisticas();
      dispatch(getEstadisticasCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getEstadisticasFailed(error));
    }
  };
};

const estadisticasInitialState: EstadisticasState = {
  isLoading: false,
  estadisticas: null,
  totalRegistros: 0,
};

const estadisticasReducer = handleActions<EstadisticasState, any>(
  {
    [setInitialState.toString()]: (
      state: EstadisticasState
    ): EstadisticasState => {
      return {
        ...estadisticasInitialState,
        take: state.take,
        estadisticas: null,
        isLoading: true,
      };
    },
    [getEstadisticasInited.toString()]: (
      state: EstadisticasState
    ): EstadisticasState => {
      return {
        ...state,
        totalRegistros: 0,
        isLoading: true,
      };
    },
    [getEstadisticasCompleted.toString()]: (
      state: EstadisticasState,
      action: Action<GetEstadisticasCompletedPayload>
    ): EstadisticasState => {
      return {
        ...state,
        estadisticas: action.payload.estadisticas,
        totalRegistros: action.payload.totalRegistros,
        isLoading: false,
        failed: false,
      };
    },
    [getEstadisticasFailed.toString()]: (
      state: EstadisticasState
    ): EstadisticasState => {
      return {
        ...state,
        isPageAlreadyLoad: false,
        isLoading: false,
        failed: true,
      };
    },
  },
  estadisticasInitialState
);

export { estadisticasReducer };
export { getEstadisticas, setInitialState };
